import React, { useState } from 'react';
import { Modal, Pill } from '@fabric-ds/react';
import Close from '../icons/Close';
import BankID from '../icons/BankID';
import Security from '../icons/Security';
import VerificationBadge from '../icons/VerificationBadge';
import SchibstedLogo from '../icons/SchibstedLogo';

type PopupProps = {
    onModalClose?: () => void;
    onBankIdVerify?: () => void;
};

export default function Popup(props: PopupProps): React.ReactElement {
    const [open, setOpen] = useState(true);
    const href = `/auth/verifyUser?redirectUrl=${encodeURIComponent(
        window.location.href,
    )}`;
    const { onModalClose = () => undefined, onBankIdVerify = () => undefined } =
        props;

    const handleCloseModal = () => {
        onModalClose();
        setOpen(false);
    };

    return (
        <Modal open={open}>
            <div className="relative">
                <div className="float-right sticky top-0">
                    <Pill
                        icon={<Close />}
                        onClick={() => handleCloseModal()}
                        className="mt-4 py-12"
                        suggestion
                    />
                </div>
                <div className="px-32 sm:px-16" style={{ height: '100%' }}>
                    <div className="flex justify-center mb-16 ">
                        <Security />
                    </div>
                    <h3 className="text-center mb-4">
                        På tide å fornye BankID-verifiseringen din!
                    </h3>
                    <p className="text-center text-14 mb-8 ">
                        Bekreft at du er deg med BankID for å ikke <br />
                        miste verifiseringen din.
                    </p>
                    <div className="flex items-center">
                        <VerificationBadge />
                        <p className="text-14 ml-8 my-8">
                            Du viser andre at du er troverdig
                        </p>
                    </div>
                    <div className="flex items-center">
                        <VerificationBadge />
                        <p className="text-14 ml-8 my-8">
                            Øker sjansen din for en vellykket handel
                        </p>
                    </div>
                    <div className="flex items-center">
                        <VerificationBadge />
                        <p className="text-14 ml-8 my-8">
                            Du får tilgang til alle funksjoner på FINN
                        </p>
                    </div>
                    <div className="mt-16 mb-24">
                        <a
                            className="button button--cta max-w-full w-full flex items-center"
                            href={href}
                            onClick={onBankIdVerify}
                            style={{ color: 'white' }}
                        >
                            <BankID
                                height="26px"
                                width="30px"
                                className="mr-8"
                            />
                            Verifiser med BankID
                        </a>
                    </div>
                    <p className="text-center text-14 mb-2">
                        FINN.no er en del av Schibsted.
                    </p>
                    <div className="flex justify-center">
                        <SchibstedLogo width="95px" />
                    </div>
                </div>
            </div>
        </Modal>
    );
}
